// frontend/admin-portal/src/routes/domains/systemRoutes.jsx
import React from "react";
import { Route } from "react-router-dom";
import { PermissionRoute } from "@fiberhome/shared-ui";

import Users from "../../pages/Users";
import Roles from "../../pages/Roles";
import Settings from "../../pages/Settings";
import Profile from "../../pages/Profile";

export default function SystemRoutes() {
  return (
    <>
      <Route element={<PermissionRoute permission="users.read" />}>
        <Route path="users" element={<Users />} />
      </Route>

      <Route element={<PermissionRoute permission="roles.read" />}>
        <Route path="roles" element={<Roles />} />
      </Route>

      <Route element={<PermissionRoute permission="settings.read" />}>
        <Route path="settings" element={<Settings />} />
      </Route>

      <Route element={<PermissionRoute permission="settings.read" />}>
        <Route path="profile" element={<Profile />} />
      </Route>
    </>
  );
}
